<template>
  <div class="flex w-full animate-pulse">
    <!-- Left Column -->
    <div class="w-full md:w-1/2 bg-secondary md:border-r border-dark-100/50">
      <div class="mx-auto max-w-[512px] px-6 pb-12 pt-28 md:pb-24 space-y-4">
        <!-- Back Button -->
        <div class="h-4 bg-dark-100/60 rounded-full w-1/4" />
        <!-- Title -->
        <div class="h-6 bg-dark-100/60 rounded w-1/2" />
        <!-- Subtitle -->
        <div class="h-6 bg-dark-100/60 rounded w-2/3" />
        <!-- Image Placeholder -->
        <div class="h-48 bg-dark-100/60 rounded" />
      </div>
    </div>
    <!-- Right Column -->
    <div class="bg-white md:w-1/2">
      <div class="mx-auto max-w-[560px] md:px-6 pb-12 pt-28 md:pb-20 space-y-4">
        <!-- Title -->
        <div class="h-4 bg-dark-100/60 rounded w-1/2" />
        <!-- Input fields -->
        <div class="h-10 bg-dark-100/60 rounded" />
        <div class="h-10 bg-dark-100/60 rounded w-8/12" />
        <div class="h-10 bg-dark-100/60 rounded w-7/12" />
        <div class="h-10 bg-dark-100/60 rounded w-8/12" />
        <!-- Large Button -->
        <div class="h-12 bg-dark-100/60 rounded" />
      </div>
    </div>
  </div>
</template>
